import React from 'react';
import { connect } from 'react-redux';
import { compose, isEmpty, mergeDeepRight, is } from 'ramda';
import { Map, fromJS } from 'immutable';


import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry.jsx';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import styleFile from './NewCofForm.js';
import { RichText, Image } from '@synergycms_core/components/generic';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import format from 'string-template';
import Form from '@synergycms_core/components/generic/Form';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import { getPenalties } from '../../utils/penalties';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import moment from 'moment';
import { Loading } from '@synergycms_core/components/functional/Loading';
import { AR_STATES, PCI_URL } from '../../config/constants';
import PciFrame from '../../components/functional/CustomerForm/PciFrame';
import { apiGetter } from '@synergycms_core/utils/api';
import { hashSpliter } from '@synergycms_core/utils';

import AvailMainSideSummaryTMS from '../../components/functional/AvailMainSideSummary/AvailMainSideSummaryTMS.jsx';
import AvailSummaryTMS from '../../components/functional/AvailSummayTMS/AvailSummaryTMS.jsx';
import actions from '../../store/actions';

const { customer: customerActions } = actions;

export const LoadingNewCof = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos confirmando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

const PaymentTitle = props => {
  const { classes, isTMSRequest } = props;
  const { reservation, fromTMS, hotelName, reservationTMS, prepaymentAmount, prepaymenID, cardMask, isGroup } = props;

  const fullName = !fromTMS ? (
      (reservation.getIn(['customer', 'name']) ? ` ${reservation.getIn(['customer', 'name'])}` : '') +
      (reservation.getIn(['customer', 'surname']) ? ` ${reservation.getIn(['customer', 'surname'])}` : '')) :
    reservation.get('name');
  const fullTracking = `${reservation.get('hotel_code')}-${reservation.get('tracking_id')}`;
  const reservationType = reservationTMS && reservationTMS.get('status_id') !== '02' && prepaymenID;
  let cardMaskFormatted = cardMask.toString();
  cardMaskFormatted = cardMaskFormatted.replace(/^.{6}/g, '******');
  let cardMaskSeparated = cardMaskFormatted.match(/.{1,4}/g).join(' ');
  const isExtraPayment = reservationTMS && reservationTMS.get('is_prepayment', false) && prepaymenID;
  const applySynergyText = !isTMSRequest || (isTMSRequest && (reservationTMS && !(reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && !isExtraPayment));
  let component;
  switch (true) {
    case reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && prepaymenID:
      component = <RichText translate={true} ucFirst={false}
                            text={'_%para poder finalizar el proceso de tu reserva, es necesario realizar el pago%_'}
                            innerStyle={['roboto16Black']}/>;
      break;
    case reservationTMS && reservationTMS.get('status_id') !== '02' && reservationTMS.get('status_id') !== '01' && prepaymenID:
      component =
        <>
          <RichText
            translate={true}
            ucFirst={false}
            text={'_%puedes realizar el pago de tu reserva en el {hotelName} en concepto de {textAmount} por un importe de {amount}{currency}%_'}
            innerStyle={['roboto16Black']}
            withVars={{
              hotelName: hotelName,
              textAmount: reservationTMS.get('text'),
              amount: prepaymentAmount,
              currency: reservationTMS.get('currency')
            }}
          />
        </>;
      break;
    default:
      component =
        <>
          <RichText translate={true} ucFirst={false}
                    text={'_%por favor, para finalizar el proceso y garantizar tu estancia, actualiza los siguientes datos de tu tarjeta.%_'}
                    innerStyle={['roboto16Black']}/>
        </>;
      break;
  }
  return (
    <div className={classes.resumeSimpleContainer}>
      <div className={classes.resumeSimple}>
        <div className={classes.title}>
          <Image innerStyle={classes.bookIcon} svg={reservationType ? 'bookIconNoCheck' : 'tmsCard'}/>
          {
            reservationType ?
              <RichText translate={true} ucFirst={true} text={'_%reserva con pago pendiente%_'}/> :
              <RichText translate={true} ucFirst={true} text={'_%actualizar los datos de tu tarjeta%_'}/>
          }
        </div>
        <div className={classes.locatorBox}>
          <RichText translate={true} ucFirst={true} text={'_%localizador%_'} innerStyle={classes.locatorTitle}/>
          <RichText text={fullTracking} innerStyle={classes.locatorValue}/>
        </div>
      </div>
      <div className={classes.resumeInformation}>
        {isGroup && <span><RichText translate={true} ucFirst={false}
                                    dangerouslySetInnerHTML={'_%Estimado,<br/>En referencia a%_'}
                                    innerStyle={['roboto16Black']}/>&nbsp;</span>}
        {
          applySynergyText ? <div
            className={cardMask !== 'NO_TOKEN' && !fromTMS && !prepaymentAmount ? [classes.paddedText, classes.creditCard].join(' ') : classes.hide}>
            <RichText
              translate={true}
              ucFirst={true}
              text={
                '_%tarjeta actual%_'
              }
            />
            <RichText
              ucFirst={true}
              text={': ' + cardMaskSeparated}
            />
          </div> : ''
        }
        <div className={classes.reservationTMSText}>
          <RichText text={fullName} innerStyle={['roboto16Black', 'bold']}/>&nbsp;
          {component}
        </div>
      </div>
    </div>
  );
};

const ConfirmationSimple = props => {
  const { classes } = props;
  const { reservation, fromTMS, reservationTMS, isExtraPayment, isTMSRequest } = props;
  const fullName = !fromTMS ? (
      reservation.getIn(['customer', 'name']) +
      (reservation.getIn(['customer', 'surname']) ? ` ${reservation.getIn(['customer', 'surname'])}` : '')) :
    reservation.get('name');
  const email = isTMSRequest ? props.reservation.getIn(['email']) : reservation.getIn(['customer', 'email']);
  const phone = isTMSRequest ? props.reservation.getIn(['telephone'], false) : reservation.getIn(['customer', 'phone'], false);
  const fullTracking = `${reservation.get('hotel_code')}-${reservation.get('tracking_id')}`;
  return (
    <div className={classes.confirmationContainer}>
      <div className={classes.confirmationContent}>
        <div className={classes.customer}>
          <div className={classes.titleConfirmation}>
            <div>
              <Image innerStyle={classes.bookIconConfirmation}
                     svg={isTMSRequest && isExtraPayment ? 'bookIcon' : 'tmsCardCheck'}/>
              {
                isTMSRequest ? (
                  !isExtraPayment ?
                    <RichText translate={true} ucFirst={true}
                              text={'_%gracias por actualizar los datos de tu tarjeta%_'}/> :
                    <RichText translate={true} ucFirst={true} text={'_%tu pago se ha realizado correctamente%_'}/>
                ) : <RichText translate={true} ucFirst={true}
                              text={'_%gracias por actualizar los datos de tu tarjeta%_'}/>
              }
              {isTMSRequest && isExtraPayment ?
                <div>
                  <RichText text={fullName}/>
                </div> :
                <div>
                  <RichText translate={true} ucFirst={true} text={'_%¡Tu reserva ya está garantizada!%_'}
                            innerStyle={classes.subtitleConfirmation}/>
                </div>}
            </div>
          </div>
          {fromTMS && !(isExtraPayment === true && reservationTMS.get('status_id') !== '02' && reservationTMS.get('status_id') !== '01') &&
            <div className={classes.body}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%en breve recibirás un email con la confirmación de tu reserva a%_'}
              />
              <a href={'mail:to'} className={classes.email}>
                {email}
              </a>
              {phone && (
                <span>
                .{' '}
                  <RichText
                    translate={true}
                    ucFirst={true}
                    text={'_%si necesitamos contactar contigo lo haremos a través del número de teléfono%_'}
                  />{' '}
                  <RichText text={phone}/>
              </span>
              )}
            </div>}
        </div>
        <div className={classes.simpleBookingInfo}>
          <div className={classes.locatorBoxConfirmation}>
            <RichText translate={true} ucFirst={true} text={'_%localizador%_'} innerStyle={classes.locatorTitle}/>
            <RichText text={fullTracking} innerStyle={classes.locatorValue}/>
          </div>
        </div>
      </div>
    </div>
  );
};

class NewCofForm extends React.Component {
  static displayName = 'NewCofForm';
  /** @type {string} */
  formID = 'newCofForm';
  /** @type {boolean | string} */
  tpvEnabled = false;
  /** @type {boolean} */
  hasCVVFilled = false;
  /** @type {boolean} */
  showCountrySelector = false;


  constructor(props) {
    super(props);
    const { hotel, cofStatusURL, reservation, reservationTMS, countries } = this.props.config;

    this.tpvEnabled = hotel.getIn(['tpv', 'name'], false);

    const paymentToken = reservation && (reservation.getIn(['payment', 'token'], false) || reservation.getIn(['token'], false));
    if (typeof paymentToken === 'string') {
      this.paymentToken = paymentToken;
    }

    this.defaultCountry = this.selectedCountry =
      countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
      countries.find(country => country.get('alpha2') === 'ES');

    this.state = {
      showCardValidationError: cofStatusURL === 'COF:ERROR',
      showPciFrame: true,
      newCofSuccess: false,
      newCofError: false
    };

    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));
    this.showCountrySelector = !country;

    window.addEventListener('message', this.overrideHeight, false);
  }

  requestNewCof = (validForm, inputList, manageLoading) => {
    const { reservation, reservationTMS, fromTMS, tmsTracking } = this.props.config;
    let { prepaymentID } = this.props.config;
    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));
    if (country === 'AR') {
      this.props.config.saveCustomerData(validForm, inputList, 'state');
    }
    //const requestWithPCIFrame = inputList['newCard'].value;
    const requestWithPCIFrame = true;
    //const hasToken = typeof this.paymentToken === 'string' && this.paymentToken.length > 0;
    if (manageLoading) {
      manageLoading(true);
    }

    if (Number.isInteger(prepaymentID)) {
      const payment = reservationTMS.get('payment');
      const additional_cards = payment.get('additional_cards');
      const isPaid = additional_cards.some(prepayment => 
        prepayment.prepayment_id === prepaymentID && prepayment.state === "payed"
      );
      if (isPaid) {
        this.changeProcessState(true);
        return true;
      }
    } else {
      prepaymentID = reservationTMS?.get('prepayment_id', false);
    }

    return new Promise((resolve, reject) => {
      //if (!prepaymentAmount && !this.hasCVVFilled && hasToken) {
      if (false) {
        this.receiveMessagePCIFunction = this.receiveMessage(validForm, inputList, resolve, reject);
        window.addEventListener('message', this.receiveMessagePCIFunction, false);
        this.pciFrameCVV.contentWindow.postMessage('submit_pci_form_cvv', PCI_URL);
      } else if (!requestWithPCIFrame) {
        const apiPci = apiGetter('pci');
        const trackingID = reservation.get('tracking_id');
        const hotelCode = reservation.get('hotel_code');
        const pinCode = reservation.get('pin_code');
        const tokenID = reservation.getIn(['payment', 'token']);
        const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingID + ':' + pinCode) }];
        const body = {
          hotel_code: hotelCode,
          token_id: tokenID,
          tpv: this.tpvEnabled,
          test: process.env.NODE_ENV !== 'production' ? 1 : 0,
          payment_recurring_type: 'newCof',
          location: window.location.href,
          from_tms: (fromTMS ? 1 : 0)
        };
        if (tmsTracking) {
          body.tms_tracking = tmsTracking;
        }
        if (prepaymentID) {
          body.prepayment_id = prepaymentID;
        }


        return apiPci.query('POST', 'CardsApp/requestWithCof', null, body, extraHeaders).then(response => {
          if (!(response.success === false)) {
            if (!(response.redirection_3ds === false)) {
              window.location.replace(response.redirection_3ds);
              return true;
            } else if (!(response.form === false)) {
              let form = atob(response.form);
              let queryObj = {};
              let redsysApi;
              if (form.indexOf('new') !== -1) {
                const [, creq, url] = form.split('#');
                queryObj.creq = creq;
                redsysApi = apiGetter(url, 'form');
              } else {
                const [, PaReq, TermUrl, MD, url] = form.split('#');
                queryObj.PaReq = PaReq;
                queryObj.TermUrl = TermUrl;
                queryObj.MD = MD;
                redsysApi = apiGetter(url, 'form');
              }
              redsysApi.post(queryObj);
              return true;

            } else {
              this.changeProcessState(true);
              return true;
            }
          } else {
            this.changeProcessState(false);
            return { error: 'Api Error' };
          }
        }).catch(() => {
          this.changeProcessState(false);
          return reject({ error: 'Api Error' });
        });
      } else {
        this.receiveMessagePCIFunction = this.receiveMessage(validForm, inputList, resolve, reject);
        window.addEventListener('message', this.receiveMessagePCIFunction, false);
        this.pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
      }
    });
  };

  changeProcessState = (success) => {
    this.setState(state => {
      if (success) {
        return { newCofSuccess: true };
      } else {
        return { newCofError: true };
      }
    });
  };

  receiveMessage = (validForm, inputList, resolve, reject) => e => {
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('submit_booking_form_from_cvv') !== -1) {
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        this.hasCVVFilled = true;
        window.removeEventListener('message', this.receiveMessagePCIFunction, false);
        this.requestNewCof(validForm, inputList);
      }
    } else if (e.origin === PCI_URL && message.indexOf('submit_booking_form') !== -1) {
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        window.removeEventListener('message', this.receiveMessagePCIFunction, false);
        this.setState(state =>
          mergeDeepRight(state, {
            showCardValidationError: false,
            newCofSuccess: true
          })
        );
        resolve();
      }
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form_cvv') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      // scroll to first unvalid
      this.pciFrameCVV.scrollIntoView();
      window.scrollBy(0, -65);
      reject();
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.setState(state =>
        mergeDeepRight(state, {
          showCardValidationError: true
        })
      );
      // scroll to first unvalid
      this.pciFrame.scrollIntoView();
      window.scrollBy(0, -65);
      reject();
    } else if (e.origin === PCI_URL && message.indexOf('redirect_3ds') !== -1) {
      const [, paymentToken, url3DSecureRedirection] = message.split('#');
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.paymentToken = paymentToken;
      window.location.replace(url3DSecureRedirection);
    } else if (e.origin === PCI_URL && message.indexOf('FORM') !== -1) {
      const [, paymentToken, form] = message.split('#');
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let queryObj = {};
      let redsysApi;
      if (decodedForm.indexOf('new') !== -1) {
        const [, creq, url] = decodedForm.split('#');
        queryObj.creq = creq;
        redsysApi = apiGetter(url, 'form');
      } else {
        const [, PaReq, TermUrl, MD, url] = decodedForm.split('#');
        queryObj.PaReq = PaReq;
        queryObj.TermUrl = TermUrl;
        queryObj.MD = MD;
        redsysApi = apiGetter(url, 'form');
      }

      redsysApi.post(queryObj);
    }

    return true;
  };

  overrideHeight = e => {
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('pci_iframe_with') !== -1) {
      let pciIframeHeight;
      [, pciIframeHeight] = message.split(':');
      if (!(parseInt(pciIframeHeight, 10) === 0 && parseInt(this.state.pciIframeHeight, 10) > 0)) {
        this.setState({
          pciIframeHeight: pciIframeHeight
        });
      }
    }
  };

  setPciFrameRef = ref => {
    this.pciFrame = ref;
  };

  setPciFrameCVVRef = ref => {
    this.pciFrameCVV = ref;
  };

  onBlur = (validForm, inputList, model, stateRetriever) => {
    if (model.indexOf('newCard') !== -1) {
      this.setState(state =>
        mergeDeepRight(state, {
          showPciFrame: inputList['newCard'].value
        })
      );
    } else {
      console.log(model);
      this.props.config.saveCustomerData(validForm, inputList, model);
    }
  };

  componentDidMount(prevProps, prevState, snapshot) {
    const { cofStatusURL, reservation, reservationTMS, hasCVV, tmsTracking } = this.props.config;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }
    if (this.state.showCardValidationError) {
      this.refs['card_validation_error'].scrollIntoView();
    }

    const cofTxid = tmsTracking ? reservationTMS.getIn(['payment', 'cof_transaction_id'], false) : reservation.getIn(['payment', 'cof_transaction_id'], false);
    if (cofStatusURL === 'COF:OK' || (cofTxid !== false && !isEmpty(cofTxid))) {
      this.changeProcessState(true);
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { hasCVV } = this.props.config;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.overrideHeight, false);
    window.removeEventListener('message', this.receiveMessagePCIFunction, false);
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  render() {
    const {
      reservation,
      hotel,
      cardMask,
      trackingFull,
      hasCVV,
      fromTMS,
      countries,
      reservationTMS,
      tmsTracking,
      prepaymentID,
      isTMSRequest,
      langInfo
    } = this.props.config;

    let { prepaymentAmount } = this.props.config;
    const { content } = this.props;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }

    const hotelCode = hotel && hotel.get('code');
    const showCVC = hotel && hotel.getIn(['payment_info', 'show_cvc']) ? 1 : 0;
    const trackingId = reservation && reservation.get('tracking_id');
    const checkin = moment(reservation && reservation.get('checkin'));
    const stayLength = reservation && reservation.getIn(['blocks', 0, 'days']);
    const checkinPCI = checkin && moment(checkin).format('DDMMYYYY');
    const checkoutPCI =
      checkin &&
      moment(checkin)
        .add(stayLength, 'days')
        .format('DDMMYYYY');

    let phoneText = format(content.t(
        '_%no hemos podido validar tu tarjeta. Por favor, revisa que tus datos, la caducidad y el CVV sean correctos o prueba con otra tarjeta. Si el problema persiste puedes contactar con nuestra central de reservas llamando al {reservation_phone}.%_'),
      { reservation_phone: content.t('_%reservation_phone%_') }
    );

    let langCode = reservationTMS && reservationTMS.getIn(['language'], false);
    if (!langCode) {
      langCode = reservation && (reservation.getIn(['customer', 'lang'], false));
    }
    if (!langCode) {
      langCode = 'en';
    }
    langCode = langCode.toLowerCase();

    let pciLangCode = langInfo.getIn(['code'], 'en');
    pciLangCode = pciLangCode.toLowerCase();
    if (pciLangCode === 'de') {
      pciLangCode = 'al';
    }
    const { classes } = this.props.theme.styles;
    const TPVActive = hotel && this.tpvEnabled !== false;
    const reservationTmsStatus = (reservationTMS.get('status_id') === '06' || reservationTMS.get('status_id') === '05') ? 'cancelled' : 'confirmed';
    const reservationStatus = fromTMS ? reservationTmsStatus : reservation.get('status', null);
    prepaymentAmount = prepaymentAmount === false ? reservationTMS && reservationTMS.get('amount', 0) : prepaymentAmount;
    const amountToPay = fromTMS ? prepaymentAmount :
      (prepaymentAmount ? prepaymentAmount : hotel.get('show_taxes') ? reservation.get('total_price_tax') : reservation.get('total_price'));

    //const hasToken = typeof this.paymentToken === 'string' && this.paymentToken.length > 0;
    //const totalPrice = reservationTMS ? parseFloat(reservationTMS.get('room_amount', 0)) + parseFloat(reservationTMS.get('extra_amount', 0)) : reservation.get('total_price_tax');
    const isExtraPayment = reservationTMS && prepaymentID && prepaymentAmount > 0;
    const isGroup = reservationTMS && reservationTMS.get('is_group', false);
    const hideGuaranteText = fromTMS && !(reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01'));
    const applySynergyText = !isTMSRequest || (!fromTMS && (reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && !prepaymentAmount));
    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));
    const showStateSelector = country === 'AR';
    const currentState = (reservation && reservation.getIn(['customer', 'state'], false)) || (reservationTMS && reservationTMS.get('state', false));
    const states = fromJS(AR_STATES);

    // Check if the prepayment is already paid
    if (prepaymentID) {
      const payment = reservationTMS.get('payment');
      const additional_cards = payment.get('additional_cards') || [];
      const isPaid = additional_cards.some(prepayment =>         
        prepayment.get("prepayment_id") === prepaymentID && prepayment.get("state") === "payed"
      );
      if (isPaid) {
        return (
          <>
            <ConfirmationSimple reservation={reservation} fromTMS={fromTMS} classes={classes}
                                reservationTMS={reservationTMS} isExtraPayment={isExtraPayment}
                                trackingFull={trackingFull} isTMSRequest={isTMSRequest}/>
          </>
        );
      }
    } 

    if (!reservation) {
      return false;
    } else if (this.state.newCofSuccess || !TPVActive) {
      return (
        <>
          <ConfirmationSimple reservation={reservation} fromTMS={fromTMS} classes={classes}
                              reservationTMS={reservationTMS} isExtraPayment={isExtraPayment}
                              trackingFull={trackingFull} isTMSRequest={isTMSRequest}/>
          <AvailSummaryTMS/>
        </>
      );
    } else if (
      reservation.get('success') === false ||
      reservationStatus === 'cancelled' ||
      this.state.newCofError
    ) {
      return (
        <div className={classes.newCofContainer}>
          <div>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%confirmación denegada%_'}
              innerStyle={[classes.mainTitle, 'mainColor']}
            />
          </div>
          <div className={classes.paddedText}>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%ha ocurrido un problema al intentar confirmar esta reserva.%_'}
            />
          </div>
        </div>
      );
    } else if (reservationStatus === 'confirmed') {
      return (
        <div className={classes.defaultStyle}>
          <div className={classes.pendingContainer}>
            <div className={classes.payContainer}>
              <Form
                loadingTemplate={LoadingNewCof}
                onSubmit={this.requestNewCof}
                onBlur={this.onBlur}
                id={this.formID}
                disableLoading={true}
                innerStyle={classes.customerForm}>
                <PaymentTitle reservation={reservation} fromTMS={fromTMS} classes={classes}
                              reservationTMS={reservationTMS} isGroup={isGroup}
                              prepaymentID={prepaymentID}
                              hotelName={hotel.get('name')} isTMSRequest={isTMSRequest} cardMask={cardMask}/>

                <div className={classes.countryContainer}>
                  {this.showCountrySelector &&
                    <SelectCountry defaultCountry={this.defaultCountry} countries={countries} arrowPosition={langCode}
                                   hidePhonePrefix={true}/>
                  }
                  {showStateSelector && <div className={classes.cityContainer}>
                    <SelectField
                      getOptionLabel={option => option.get('name')}
                      getOptionValue={option => option.get('code')}
                      model={'state'}
                      innerStyle={[classes.citySelector]}
                      defaultValue={states.find(s => s.get('code') === currentState) || states.first()}
                      options={states}
                    />
                  </div>}
                </div>

                {/*
                <div
                  className={cardMask !== 'NO_TOKEN' && !fromTMS && !prepaymentAmount ? [classes.paddedText, classes.conditions].join(' ') : classes.hide}>
                  <RichText
                    translate={true}
                    ucFirst={true}
                    text={
                      '_%reserva garantizada con tarjeta%_'
                    }
                  />
                  <RichText
                    translate={true}
                    ucFirst={true}
                    text={': ' + cardMask}
                  />
                </div>
                */}

                <div className={classes.payComponent}>
                  {/*
                  {
                    !hasCVV && hasToken &&
                    <div
                      className={this.state.showPciFrame ? classes.hide : classes.wrapperPciFrame}>
                      <PciFrameCVV
                        langCode={langCode}
                        cardTokenId={this.paymentToken}
                        setRef={this.setPciFrameCVVRef}
                      />
                    </div>
                  }
                  <label className={hasToken && !fromTMS && !prepaymentAmount ? classes.checkBox : classes.hide}>
                    <CheckboxField
                      defaultValue={this.state.showPciFrame}
                      type={'checkbox'}
                      model={'newCard'}
                      innerStyle={['inputCheck', classes.inputCheck]}
                    />
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={
                        '_%marca esta casilla si prefieres dejar otra tarjeta distinta como garantía de tu reserva%_'
                      }
                      innerStyle={classes.checkBoxText}
                    />
                  </label>
                  */}
                  {<div style={{ height: this.state.pciIframeHeight + 'px' }}
                        className={this.state.showPciFrame ? classes.wrapperPciFrame : classes.hide}>

                    <PciFrame
                      langCode={pciLangCode}
                      trackingId={trackingId}
                      tmsTracking={tmsTracking}
                      hotelCode={hotelCode}
                      checkinPCI={checkinPCI}
                      checkoutPCI={checkoutPCI}
                      showCVC={showCVC}
                      cfees15d={'0'}
                      tpvEnabled={this.tpvEnabled}
                      withCof={true}
                      requiredPrepayment={fromTMS ? amountToPay : (prepaymentAmount ? prepaymentAmount : 0)}
                      prepaymentID={prepaymentID}
                      fromTms={fromTMS}
                      setRef={this.setPciFrameRef}
                      cardTokenId={false}
                      cardVerification={hotel.getIn(['pci', 'card_verification'], false)}
                      hideText={!isTMSRequest ? false : hideGuaranteText}
                    />
                  </div>}
                  {this.state.showCardValidationError && (
                    <div className={classes.errorPCI} ref={'card_validation_error'}>
                      <RichText
                        text={phoneText}
                        translate={true}
                        innerStyle={['errorForm15']}
                        ucFirst={true}
                      />
                    </div>
                  )}
                </div>
                <div className={classes.finalPrice}>
                  <div className={classes.tableContainer}>
                    {/* {reservationTMS && ((reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') || (reservationTMS.get('status_id') !== '02' && reservationTMS.get('status_id') !== '01')) && reservationTMS.get('amount', 0) > 0 && reservationTMS.get('amount', 0) > 0 &&
                    <>
                      <div className={classes.tableCell}>
                        <RichText text={'_%precio total%_'} innerStyle={['totalPrice']} ucFirst={true}
                                  translate={true}/>
                        <TaxIncluded showTaxes={showTaxes}/>
                      </div>
                      <div className={classes.tableCell}>
                        <Price
                          innerStyle={['summaryPriceBig']}
                          amount={totalPrice}
                          forceHotelCurrency={true}
                        />
                      </div>
                    </>} */}
                    <div className={[classes.buttonContainer, applySynergyText && classes.noPaddingButton].join(' ')}>
                      <ButtonSubmit
                        richText={{
                          text: applySynergyText ? '_%actualizar tarjeta%_' : (isExtraPayment ? '_%realizar pago%_' : '_%confirmar reserva%_'),
                          translate: true,
                          ucFirst: true,
                          innerStyle: ['toggleSecondButton']
                        }}
                        innerStyle={['toggleSecondButton']}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            </div>
            {!this.isMobile() && <div className={classes.resumeContainer}>
              <AvailMainSideSummaryTMS innerStyle={'pendingConfirmationStyle'}
                                       newCofSuccess={this.state.newCofSuccess || !TPVActive}
                                       fullVersion={true}
                                       isGroup={isGroup}/>
            </div>
            }
          </div>
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    saveCustomerData: (validForm, inputList, model) => {
      if (ownProps.fromTMS) {
        return dispatch(customerActions.reservation.patchTmsAsync([model], inputList));
      } else {
        return dispatch(customerActions.reservation.patchAsync([model], inputList));
      }
    }
  };
};


const mapStateToProps = store => {
  const queryParams = store.getIn(['customer', 'params', 'url_params'], false);
  const fromTMS = store.getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true';
  const tmsTracking = store.getIn(['customer', 'params', 'url_params', 'tms_tracking'], false);
  const prepaymentID = store.getIn(['customer', 'params', 'url_params', 'prepayment_id'], false);
  const prepaymentAmount = store.getIn(['customer', 'params', 'url_params', 'prepayment_amount'], false);
  const storeResevation = store.getIn(['customer', 'reservation']);
  const reservation = storeResevation.size ? storeResevation : undefined;
  let penalties;
  if (!fromTMS) {
    penalties = reservation && reservation.get('success') !== false && getPenalties(reservation);
  }
  const isVcCard = reservation && reservation.getIn(['payment', 'payform_code'], false) === 'vc';
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotel = store.getIn(['hotels', hotelId], undefined);
  const cardMask = isVcCard ? 'NO_TOKEN' : store.getIn(['customer', 'card_mask']);
  const hasCVV = store.getIn(['customer', 'has_cvv']);
  const cofStatusURL = hashSpliter(window.location.hash)[3] || false;

  let trackingFull = reservation && (reservation.get('hotel_code') + '-' + reservation.get('tracking_id'));
  const isCnnBooking = reservation && reservation.getIn(['connectivity', 'code'], false) && reservation.getIn(['connectivity', 'tracking_id'], false);

  if (isCnnBooking) {
    let connectivityCode = reservation.getIn(['connectivity', 'code'], false);
    if (connectivityCode === 'ECIOLD') {
      connectivityCode = 'ECI';
    }
    if (connectivityCode === 'BOOKINGS') {
      connectivityCode = 'BOOKING';
    }
    trackingFull = connectivityCode + '-' + reservation.getIn(['connectivity', 'tracking_id']);
  }


  let reservationTMS = reservation && (reservation.get('tms_reservation', false) || reservation);
  const isTMSRequest = fromTMS || (!fromTMS && tmsTracking);
  if (tmsTracking && reservationTMS && !fromTMS) {
    reservationTMS = reservationTMS.find(
      r => r.get('tracking_id') === parseInt(tmsTracking, 10)
    );
  }

  return {
    params: store.getIn(['customer', 'params', 'params']),
    queryParams: queryParams || undefined,
    reservation: reservation,
    reservationTMS: reservationTMS,
    penalties: !fromTMS ? penalties : [],
    hotel: hotel,
    cardMask: cardMask && cardMask.length > 0 ? cardMask : (typeof hasCVV.error ? false : undefined),
    hasCVV: typeof hasCVV === 'boolean' ? hasCVV : (typeof hasCVV.error ? false : undefined),
    cofStatusURL: cofStatusURL,
    trackingFull: trackingFull,
    fromTMS: fromTMS,
    tmsTracking: tmsTracking,
    prepaymentID: prepaymentID,
    prepaymentAmount: prepaymentAmount,
    showTaxes: is(Map, hotel) && hotel.size > 0 && hotel.get('name') && hotel.get('show_taxes', true),
    isTMSRequest: isTMSRequest,
    countries: store.get('countries'),
    langInfo: store.getIn(['customer', 'lang_info'])

  };
};


const fragment = props => (
  <React.Fragment>
    <Loading image={{ innerStyle: ['displayNone'] }}/>
  </React.Fragment>
);

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'params',
    'reservation',
    'reservationTMS',
    'cancelReservation',
    'triggerEvent',
    'saveCustomerData',
    'penalties',
    'hotel',
    'countries',
    'cardMask',
    'hasCVV',
    'cofStatusURL',
    'trackingFull',
    'fromTMS',
    'tmsTracking',
    'prepaymentID',
    'prepaymentAmount',
    'showTaxes',
    'isTMSRequest',
    'queryParams',
    'langInfo'
  ]),
  withThemeJSS({ styleFile, link: true, index: 200 }),
  withContent('i18n')
)(NewCofForm);
